import { useState, useEffect } from 'react';
import scanApi from '../services/api';

export const useAuth = () => {
    const [user, setUser] = useState(null);
    const [quotaInfo, setQuotaInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUserProfile = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setLoading(false);
                return;
            }

            console.log('Fetching user profile with token:', token);
            const data = await scanApi.getCurrentUser();
            console.log('User profile data:', data);

            setUser({
                username: data.username,
                name: data.name,
                role: data.role
            });

            if (data.quotaInfo) {
                setQuotaInfo({
                    used: data.quotaInfo.used,
                    total: data.quotaInfo.total,
                    remaining: data.quotaInfo.remaining
                });
            }
        } catch (error) {
            console.error('Failed to fetch user profile:', error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch on mount and when token changes
    useEffect(() => {
        fetchUserProfile();
    }, []);

    // Add method to refresh user data
    const refreshUser = () => {
        fetchUserProfile();
    };

    return { user, quotaInfo, loading, refreshUser };
};
